import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getProfilePictureURL } from '../services/profileService';
import ProfilePictureModal from './ProfilePictureModal';
import BirthdayModal from './BirthdayModal';
import './Navbar.css';

const Navbar = () => {
  const { logout, currentUser } = useAuth();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [isBirthdayModalOpen, setIsBirthdayModalOpen] = useState(false);
  const [profilePictureURL, setProfilePictureURL] = useState(null);
  const dropdownRef = useRef(null);

  const handleSignOut = async () => {
    try {
      await logout();
      setIsDropdownOpen(false);
    } catch (error) {
      console.error('Failed to sign out:', error);
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Load profile picture when user changes
  useEffect(() => {
    const loadProfilePicture = async () => {
      if (currentUser) {
        const url = await getProfilePictureURL(currentUser.uid);
        setProfilePictureURL(url);
      } else {
        setProfilePictureURL(null);
      }
    };

    loadProfilePicture();
  }, [currentUser]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Get user initials for avatar
  const getUserInitials = () => {
    if (!currentUser || !currentUser.email) return 'U';
    const email = currentUser.email;
    const name = email.split('@')[0];
    return name.charAt(0).toUpperCase();
  };

  const handleProfilePictureUpdate = (newURL) => {
    setProfilePictureURL(newURL);
  };

  const handleProfilePictureClick = () => {
    setIsProfileModalOpen(true);
    setIsDropdownOpen(false);
  };

  const handleBirthdayClick = () => {
    setIsBirthdayModalOpen(true);
    setIsDropdownOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="navbar-logo">
          status.georgekutti
        </div>
        <div className="navbar-avatar-container" ref={dropdownRef}>
          <button 
            className="navbar-avatar"
            onClick={toggleDropdown}
            aria-label="User menu"
          >
            {profilePictureURL ? (
              <img 
                src={profilePictureURL} 
                alt="Profile" 
                className="navbar-avatar-image"
              />
            ) : (
              getUserInitials()
            )}
          </button>
          {isDropdownOpen && (
            <div className="navbar-dropdown">
              <div className="navbar-dropdown-item">
                <span className="navbar-user-email">{currentUser?.email}</span>
              </div>
              <div className="navbar-dropdown-divider"></div>
              <button 
                className="navbar-dropdown-item"
                onClick={handleProfilePictureClick}
              >
                Change Profile Picture
              </button>
              <button 
                className="navbar-dropdown-item"
                onClick={handleBirthdayClick}
              >
                Set Birthday
              </button>
              <button 
                className="navbar-dropdown-item navbar-signout-item"
                onClick={handleSignOut}
              >
                Sign Out
              </button>
            </div>
          )}
        </div>
        
        <ProfilePictureModal
          isOpen={isProfileModalOpen}
          onClose={() => setIsProfileModalOpen(false)}
          onPictureUpdate={handleProfilePictureUpdate}
        />
        
        <BirthdayModal
          isOpen={isBirthdayModalOpen}
          onClose={() => setIsBirthdayModalOpen(false)}
        />
      </div>
    </nav>
  );
};

export default Navbar;
